/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { PricingCalculatorQuery } from '../models/subscriptions/pricing-calculator.query';
import { PricingCalculatorResponse } from '../models/subscriptions/pricing-calculator.response';

@Injectable({
  providedIn: 'root',
})
export class PricingCalculatorApi {
  constructor(private http: HttpClient) {}

  getPricingEstimate(request: PricingCalculatorQuery): Observable<PricingCalculatorResponse> {
    return this.http.post<PricingCalculatorResponse>(
      `${environment.servicesApiUrl}/api/v3/pricing-calculator`,
      request,
    );
  }
}
